<script setup>
import { ref, onMounted } from 'vue';
import api from '@/api';
import Swal from 'sweetalert2';
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.css';

const asistencias = ref([]);
const pagina = ref(1);
const totalPaginas = ref(1);
const limite = 10;
const from = ref('');
const to = ref('');
const cargando = ref(false);

const hoy = new Date();
const inicioMes = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
const finMes = new Date(hoy.getFullYear(), hoy.getMonth() + 1, 0);

from.value = inicioMes.toISOString().split('T')[0];
to.value = finMes.toISOString().split('T')[0];

const cargarAsistencias = async () => {
  try {
    cargando.value = true;
    const res = await api.get('/accesos/asistencias', {
      params: {
        page: pagina.value,
        limit: limite,
        from: from.value,
        to: to.value,
      },
    });
    asistencias.value = Array.isArray(res.data.data) ? res.data.data : [];
    totalPaginas.value = Math.ceil(res.data.total / limite);
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.error('Error al obtener asistencias:', error);
    Swal.fire('Error', 'No se pudieron cargar las asistencias', 'error');
  } finally {
    cargando.value = false;
  }
};

const cambiarPagina = (nueva) => {
  if (nueva >= 1 && nueva <= totalPaginas.value) {
    pagina.value = nueva;
    cargarAsistencias();
  }
};

const filtrar = () => {
  pagina.value = 1;
  cargarAsistencias();
};

const formatearFecha = (fecha) => {
  return new Date(fecha).toLocaleDateString();
};

const formatearHora = (fecha) => {
  return new Date(fecha).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

onMounted(() => {
  cargarAsistencias();
  flatpickr('.fecha-input', { dateFormat: 'Y-m-d' });
});
</script>

<template>
  <div class="container-fluid py-4">
    <div class="card p-4">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h5 class="mb-0">Asistencias</h5>
      </div>

      <div class="row mb-3 align-items-end">
        <div class="col-md-3 mb-2 mb-md-0">
          <label>Desde:</label>
          <input v-model="from" class="form-control form-control-sm fecha-input" type="text" />
        </div>
        <div class="col-md-3 mb-2 mb-md-0">
          <label>Hasta:</label>
          <input v-model="to" class="form-control form-control-sm fecha-input" type="text" />
        </div>
        <div class="col-md-2">
          <button class="btn btn-sm btn-success w-100 mb-0" @click="filtrar">
            <i class="ni ni-zoom-split-in text-white text-sm me-1"></i> Filtrar
          </button>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table table-sm custom-table text-sm">
          <thead>
            <tr>
              <th>Socio</th>
              <th>Membresía</th>
              <th>Fecha</th>
              <th>Hora</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!cargando && asistencias.length === 0">
              <td colspan="4" class="text-center">No hay asistencias</td>
            </tr>
            <tr v-for="a in asistencias" :key="a.id">
              <td>{{ a.socio }}</td>
              <td>{{ a.membresia }}</td>
              <td>{{ formatearFecha(a.fecha) }}</td>
              <td>{{ formatearHora(a.fecha) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="d-flex justify-content-between align-items-center mt-3 px-2">
        <small class="text-muted">Página {{ pagina }} de {{ totalPaginas }}</small>
        <div>
          <button class="btn btn-outline-secondary btn-sm me-2" :disabled="pagina === 1" @click="cambiarPagina(pagina - 1)">
            Anterior
          </button>
          <button class="btn btn-outline-secondary btn-sm" :disabled="pagina === totalPaginas" @click="cambiarPagina(pagina + 1)">
            Siguiente
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-table th,
.custom-table td {
  padding: 0.4rem !important;
  font-size: 0.78rem !important;
  line-height: 1.2;
}
.custom-table thead {
  background-color: #f2f2f2;
  text-transform: uppercase;
}
</style>
